/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request body for starting a bot
 * @export
 * @interface StartBotRequest
 */
export interface StartBotRequest {
    /**
     * 
     * @type {number}
     * @memberof StartBotRequest
     */
    usersCount: number;
}

/**
 * Check if a given object implements the StartBotRequest interface.
 */
export function instanceOfStartBotRequest(value: object): value is StartBotRequest {
    if (!('usersCount' in value) || value['usersCount'] === undefined) return false;
    return true;
}

export function StartBotRequestFromJSON(json: any): StartBotRequest {
    return StartBotRequestFromJSONTyped(json, false);
}

export function StartBotRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartBotRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'usersCount': json['users_count'],
    };
}

export function StartBotRequestToJSON(json: any): StartBotRequest {
    return StartBotRequestToJSONTyped(json, false);
}

export function StartBotRequestToJSONTyped(value?: StartBotRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users_count': value['usersCount'],
    };
}

